import { hasCondition } from './questions.shared.js';
import { EDUCATOR_ROLE_OPTIONS } from '../src/handbookProducts.js';

export const BASIC_QUESTIONS = [
  { id: 'childName', section: 'basics', type: 'text', question: 'Child\'s Name', placeholder: 'e.g. Amrita, Aarav', required: true },
  { id: 'grade', section: 'basics', type: 'text', question: 'School Grade / Level', placeholder: 'e.g. Grade 5, Pre-K, UKG', required: true },
  {
    id: 'pronouns',
    section: 'basics',
    type: 'single-select',
    question: 'How should the handbook refer to your child?',
    hint: 'This only helps the handbook use the right words in sentences.',
    options: ['My child is a boy (use he / him)', 'My child is a girl (use she / her)', 'Use they / them', 'Prefer not to say / use neutral language'],
    required: true,
  },
  { id: 'schoolName', section: 'basics', type: 'text', question: 'School Name (Optional)', placeholder: 'e.g. St. Mary\'s School', required: false },
  { id: 'academicYear', section: 'basics', type: 'text', question: 'Academic Year', placeholder: 'e.g. 2026-27', required: true },
  {
    id: 'condition',
    section: 'basics',
    type: 'multi-select',
    question: 'Diagnosed neurodivergent profile(s) (Select all that apply)',
    hint: 'Select the confirmed diagnosis areas you want this handbook to support. You can choose more than one.',
    options: ['ADHD (Attention, restless energy, or task-start challenges)', 'Autism (Communication, routines, social interpretation)', 'Dyslexia (Reading, spelling, and written output load)', 'Other diagnosed learning or development support area'],
    required: true,
  },
  {
    id: 'additionalProfiles',
    section: 'basics',
    type: 'multi-select',
    question: 'Which other diagnosed support areas should this handbook cover?',
    hint: 'Select what applies. These will be translated into practical classroom supports, not clinical labels.',
    options: ['Dysgraphia (writing, handwriting, or written expression load)', 'Dyscalculia (number sense, maths facts, or calculation load)', 'Developmental Coordination Disorder / Dyspraxia (motor planning or coordination)', 'Sensory Processing Disorder (formally diagnosed sensory regulation needs)', 'Language Disorder (understanding or expressing spoken language)', 'Social Communication Disorder (social language and peer communication)', 'Tourette Syndrome / Chronic Tic Disorder', 'Intellectual Disability', 'Gifted + Neurodivergent / Twice-Exceptional', 'Other diagnosed area not listed'],
    condition: (answers) => hasCondition(answers, 'Other diagnosed learning'),
    required: true,
  },
  {
    id: 'outputMode',
    section: 'basics',
    type: 'single-select',
    question: 'Handbook depth',
    hint: 'Choose the format your educator is most likely to use consistently.',
    options: ['Quick Card (1-page fast classroom reference)', 'Standard Handbook (balanced detail and readability)', 'Detailed Support Plan (expanded context and examples)'],
    required: true,
  },
  {
    id: 'educatorRole',
    section: 'basics',
    type: 'single-select',
    question: 'Handbook Prepared For (Educator Role)',
    options: EDUCATOR_ROLE_OPTIONS.map((option) => option.label),
    required: true,
  },
  {
    id: 'ageBand',
    section: 'basics',
    type: 'single-select',
    question: 'Age Band Category',
    options: ['Pre-Primary — Nursery to UKG (Ages 3–5)', 'Early Primary — Grade 1–2 (Ages 6–7)', 'Primary — Grade 3–5 (Ages 8–10)', 'Middle School — Grade 6–8 (Ages 11–13)', 'Secondary — Grade 9–10 (Ages 14–16)', 'Senior Secondary — Grade 11–12 (Ages 16–18)'],
    required: true,
  },
];
